import React from 'react';

const LandingSubText = ({ children, additionalclasses }) => {
    return (
        <p className={`text-grey-900 text-[16px] leading-[24px] text-center ${additionalclasses}`}>
            {children}
        </p>
    );
};

export default LandingSubText;